<template>
  <main id="content" v-if="user">
    <section class="pt-4 pb-4">
      <b-container style="max-width: 900px">
        <b-row>
          <b-col md="4">
            <SettingsNav />
          </b-col>
          <b-col md="8">
            <div class="card card-body" data-aos="fade-down-left">
              <h2 class="h4 mb-4" data-aos="fade-right">Profile</h2>
              <b-form @submit.prevent="settingsAction">
                <b-alert
                  show
                  variant="danger"
                  v-if="!user.emailVerified"
                  class="mb-3"
                >
                  <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
                  {{ constants.info.verify_email }}.
                  <transition name="fade">
                    <a
                      id="hyperResentText"
                      @click.prevent="resendAction"
                      href="#"
                      >{{ resent }}</a
                    >
                  </transition>
                </b-alert>
                <b-row class="mb-3">
                  <b-col cols="3" class="text-center">
                    <b-img
                      rounded="circle"
                      v-bind:src="settings.photoURL"
                      width="75"
                      height="75"
                      v-bind:alt="user.name"
                      class="m-1"
                    />
                  </b-col>
                  <b-col cols="9">
                    <b-form-group label="Name" data-aos="fade-right">
                      <b-form-input
                        id="txtProfileName"
                        type="text"
                        autocomplete="name"
                        v-model="settings.displayName"
                        v-bind:disabled="!show"
                        placeholder="Enter your full name"
                        data-aos="fade-right"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group label="Email" data-aos="fade-right">
                  <b-form-input
                    type="email"
                    autocomplete="email"
                    v-model="user.email"
                    disabled
                    data-aos="fade-right"
                  />
                </b-form-group>
                <transition name="fade">
                  <b-button
                    id="btnUpdateProfileSettings"
                    type="submit"
                    variant="primary"
                    data-aos="fade-right"
                  >
                    <span v-if="show">
                      Update settings
                      <font-awesome-icon icon="arrow-right" />
                    </span>
                    <span v-else>
                      Updating settings &nbsp;
                      <font-awesome-icon icon="sync" spin />
                    </span>
                  </b-button>
                </transition>
              </b-form>
            </div>
            <div class="card card-body">
              <h2 class="h4 mb-4" data-aos="fade-right">Password</h2>
              <b-form-group label="Change password" data-aos="fade-right">
                <p>
                  If you'd like to change your password, click on the button
                  below and we'll send you a password reset link.
                </p>
                <transition name="fade">
                  <b-button
                    id="btnProfileResetLink"
                    type="button"
                    @click.prevent="sendResetAction"
                    variant="primary"
                  >
                    <span v-if="show">{{ resetButtonText }}</span>
                    <font-awesome-icon icon="arrow-right" />
                  </b-button>
                </transition>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import {
  updateSettings,
  resendVerification,
  sendResetLink
} from "../modules/auth";
import constants from "../modules/constants";
import SettingsNav from "../components/SettingsNav.vue";
export default {
  data: () => {
    return {
      settings: {
        displayName: "",
        photoURL: "",
        initialImage: ""
      },
      show: true,
      success: null,
      constants: constants,
      error: null,
      resetButtonText: "Send reset link",
      resent: "Resent verification email"
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.settings.displayName = this.user.displayName;
    this.settings.photoURL =
      this.user.photoURL || constants.profile.default_user_image;
    this.settings.initialImage =
      this.user.photoURL || constants.profile.default_user_image;
    this.check_emailVerification();
  },
  methods: {
    resendAction() {
      if (this.resent === "Sent!") return false;
      this.resent = "Sending email...";
      resendVerification()
        .then(() => {
          this.resent = "Sent!";
        })
        .catch(() => {
          this.resent = "Error in sending email";
        });
    },
    sendResetAction() {
      if (this.resetButtonText === "Sent!") return false;
      this.resetButtonText = "Sending reset link...";
      sendResetLink(this.user.email)
        .then(() => {
          this.resetButtonText = "Sent!";
        })
        .catch(() => {
          this.resetButtonText = "Error in sending email";
        });
    },
    settingsAction() {
      this.show = false;
      updateSettings(this.settings.displayName, this.settings.photoURL)
        .then(() => {
          this.show = true;
          this.$root.toast(constants.info.profile_updated);
        })
        .catch(() => {
          this.show = true;
          this.$root.toast(constants.errors.settings_error);
        });
    },
    check_emailVerification() {
      if (!this.user.emailVerified) {
        this.$bvToast.toast(`${constants.info.verify_email}`, {
          title: "Email Verification",
          autoHideDelay: 1000,
          variant: "danger",
          toaster: "b-toaster-top-center",
          appendToast: false
        });
        // this.$root.toast(constants.info.verify_email);
      }
    }
  },
  components: {
    SettingsNav
  }
};
</script>
<style>
body {
  background-color: #fff;
}
</style>
